<template>
  <transition name="slide-up-down">
    <div v-show="active" class="slide-up-down">
      <slot />
    </div>
  </transition>
</template>

<script setup lang="ts">
  const props = defineProps({
    active: Boolean,
    duration: {
      type: Number,
      default: 300
    }
  });

  const show = ref(props.active);

  watch(
    () => props.active,
    (val) => {
      show.value = val;
    }
  );
</script>

<style scoped>
  /*
   * The clip belongs to the animation only. Leaving `overflow: hidden` on the
   * open panel also clips absolutely positioned children that legitimately
   * overhang it — e.g. the ProductDownloads dropdown at the bottom of a
   * resource card, which was cut off at the panel's edge.
   */
  .slide-up-down-enter-active,
  .slide-up-down-leave-active {
    overflow: hidden;
    transition: max-height var(--duration, 300ms) cubic-bezier(0.4, 0, 0.2, 1);
  }
  .slide-up-down-enter-from,
  .slide-up-down-leave-to {
    max-height: 0;
  }
  .slide-up-down-enter-to,
  .slide-up-down-leave-from {
    max-height: 1000px;
  }
</style>
